import React from "react";
import { Helmet } from "react-helmet-async";
import { SimpleComingSoon } from "./ComingSoon";
import LoginForm from "@/components/auth/LoginForm";
import { isComingSoonEnabled } from "@/utils/featureFlags";

const Login: React.FC = () => {
  if (isComingSoonEnabled()) return <SimpleComingSoon />;

  return (
    <>
      <Helmet>
        <title>Login | SaunaDip</title>
        <meta name="description" content="Login to your SaunaDip account" />
      </Helmet>
      <LoginForm />
    </>
  );
};

export default Login;
